import { msiRequest } from "../index";
import { ResultType } from "../types";
import { AccountLoginType, AccountLoginResultType } from "./types";
import { UserInfoType } from '@/store/login/types'
import local from '@/utils/cache'
import qs from 'qs'
enum AccountLoginAPI {
  ACCOUNT_LOGIN = "/login",
  USER_INFO = "/getLoginUser",
  USER_MENU = "role/",
  ENUMS_API = '/WareDictData/listbycodelist',
}

//获取全局使用枚举
export function getAllEnums(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${AccountLoginAPI.ENUMS_API}?${qs.stringify(data)}`
  });
}

//登录
export function accountLoginRequest(loginForm: AccountLoginType) {
  return msiRequest.post<ResultType<string>>({
    url: AccountLoginAPI.ACCOUNT_LOGIN,
    data: {
      ...loginForm
    }
  });
}

//获取用户信息
export function userInfoRequest() {
  return msiRequest.get<ResultType<UserInfoType>>({
    url: AccountLoginAPI.USER_INFO
  });
}

export function userMenuRequest(id: number) {
  return msiRequest.get<ResultType<any>>({
    url: AccountLoginAPI.USER_MENU + id + "/menu"
  });
}
